module.exports = __webpack_public_path__ + "static/media/email.bf58874b.svg";